import { ItemPredicate } from '@blueprintjs/select';

import { stringToRegExp } from 'bones/utils/regExp';
import { SELECT_ITEM_DIVIDER_VALUE } from 'bones/utils/select/createSelectItemDivider';
import { BaseSelectItem, SelectItem } from 'bones/utils/select/types';

export const selectItemPredicate =
  <SubItemType extends BaseSelectItem | null = null>(
    customFilter?: <T extends SelectItem<SubItemType>>(
      item: T,
      searchText: string
    ) => boolean
  ) =>
  (
    items: Array<SelectItem<SubItemType>>
  ): ItemPredicate<SelectItem<SubItemType>> =>
  (searchText: string, searchItem: SelectItem<SubItemType>) => {
    if (!searchText) {
      return true;
    }

    const match = <T extends SelectItem<SubItemType>>(item: T) =>
      customFilter
        ? customFilter(item, searchText)
        : item.text.match(stringToRegExp(searchText, 'i')) ||
          item.searchText?.match(stringToRegExp(searchText, 'i'));

    const recursiveMatch = <T extends SelectItem<SubItemType> | null>(
      item: T
    ): boolean =>
      Boolean(item && (match(item) || item.items?.some(recursiveMatch)));

    if (searchItem.value !== SELECT_ITEM_DIVIDER_VALUE) {
      return recursiveMatch(searchItem);
    }

    const nextMatchingItem = items
      .slice(items.indexOf(searchItem) + 1)
      .find(
        (item) =>
          item.value === SELECT_ITEM_DIVIDER_VALUE || recursiveMatch(item)
      );

    // only display a dividier when there is a matching item following it
    return Boolean(
      nextMatchingItem && nextMatchingItem.value !== SELECT_ITEM_DIVIDER_VALUE
    );
  };
